import cn from 'classnames';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import ImageViewer from 'react-simple-image-viewer';
import { changeShipmentPosting } from '../../../../actions/postings';
import PostingsApi from '../../../../API/shipment/postings-api';
import barcode_image from '../../../../assets/media/barcode-scan.png';
import chzn_icon from '../../../../assets/media/chzn.png';
import chz_active_icon from '../../../../assets/media/chzn_atcive.png';
import comment_red from '../../../../assets/media/icons/comment-grey.svg';
import default_image from '../../../../assets/media/icons/products.png';
import { Column, Row, WhiteBlock } from '../../../../components/Basic/Blocks';
import { Button, CheckButton } from '../../../../components/Basic/Buttons';
import { DropDown, Icon, NavLink } from '../../../../components/Basic/Elements';
import { DateInput, Input, Select } from '../../../../components/Basic/Inputs';
import { TableCell, TableLine } from '../../../../components/Basic/Table';
import { Text, TextGrey, Tooltip } from '../../../../components/Basic/WrapsStyle';
import BarcodesBlock from '../../../../components/Common/Input/Barcodes';
import ProviderList from '../../../../components/Common/Input/ProviderList';
import CommissionWbBlock from '../../../../components/Markets/Blocks/CommissionWbBlock';
import PackagingMethodSelect from '../../../../components/Providers/Inputs/PackagingMethodSelect';
import PostingStatusWrap from '../../../../components/Shipments/WrapStyle/PostingStatus';
import { DIFF_STATUSES, TO_POSING, TO_SHIPMENT, TYPE_BUTTONS } from '../../../../constans';
import { formFullDate, formFullDateWithSeconds, getDateMonth, getDateSolid } from '../../../../utils';
import DateDifferent from '../../../Orders/Wb/Orders/IncreasedCommissionTimerBlock';
import CommentPostingProductBlock from '../../Posting/CommentBlock';
import { WIDTH_POSTING } from '../index';
import RealQuantityInput from './RealQuantityInput';
import styles from './styles.module.scss';

const STATE = {
  not_started: { text: 'Не собран', color: '' },
  started: { text: 'Комплектуется', color: 'rgb(255 112 0 / 18%)' },
  collected: { text: 'Собран', color: 'rgb(88 143 255 / 37%)' },
  packed: { text: 'Упакован', color: 'rgb(69 255 156 / 51%)' },
  printed: { text: 'Упакован', color: '#39ee3f47' },
};

const PostingLine = ({
  onChangeCard = (_) => _,
  MODES,
  FILTER,
  tab,
  shipmentMode = true,
  order = {},
  shipment = {},
  map = {},
  postingsPrint = {},
  globalSearchCompleted = false,
  changePostingPrint = (_) => _,
  printSticker = (_) => _,
  changePrintStatus = (_) => _,
  setOpenChzn = () => { },
  isMany = false,
  isDisabledPrint = () => { },
  isExpress,
  warehouseProductsMap = {},
  onChangeWarehouseReserve = () => { },
  isAdmin = false,
  isPenaltyCandidate = false,
  ...props
}) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const [images, setImages] = useState([]);

  const [providers, setProviders] = useState([]);
  const [info, setInfo] = useState(false);
  const dispatch = useDispatch();
  const allProviders = useSelector((store) => store.providers);

  // список поставщиков
  useEffect(() => {
    const p = allProviders.filter((item) => !item.hide);
    if (p.length > 0) {
      setProviders(p);
    }
  }, [allProviders]);

  const onChangeProduct = async (id, productId, field, value, action = undefined) => {
    await PostingsApi.changeProductInPosting({ data: { postingNumber: id, productId, field, value, action } }).then(
      (r) => {
        dispatch(changeShipmentPosting(r.posting));
      },
    );
  };

  const onChangePosting = async (id, field, value) => {
    await PostingsApi.changePosting({ data: { postingNumber: id, field, value } }).then((r) => {
      dispatch(changeShipmentPosting(r.posting));
    });
  };


  const sendMetadataToMarket = async (postingNumber, productId) => {
    await PostingsApi.sendMetadata({ data: { postingNumber, productId } }).then((r) => {
      dispatch(changeShipmentPosting(r.posting));
    });
  };
  const deleteMetadataInMarket = async (postingNumber, productId) => {
    await PostingsApi.removeMetadata({ data: { postingNumber, productId } }).then((r) => {
      dispatch(changeShipmentPosting(r.posting));
    });
  };

  const openImageViewer = (images) => {
    setImages(images);
    setIsViewerOpen(true);
  };
  const closeImageViewer = () => {
    setIsViewerOpen(false);
    setImages([]);
  };

  const scan_time_order = order.scan_time?.pick ? formFullDateWithSeconds(order.scan_time.pick) : null;
  const second_scan_time_order = order.scan_time?.packager ? formFullDateWithSeconds(order.scan_time.packager) : null;
  const sort_scan_time_order = order.scan_time?.sort ? formFullDateWithSeconds(order.scan_time.sort) : null;

  const is_disabled_print = isDisabledPrint(order);

  let penalty = Math.ceil(order.products.reduce((sum, item) => sum + item.price * item.ordered_quantity, 0)) * 0.5;
  console.log('isPenaltyCandidate', isPenaltyCandidate);
  return (
    <>
      <TableLine style={order.is_printed && shipmentMode === MODES[0] ? { background: STATE['printed'].color } : {}}>
        {order.is_printed && <div className={styles.status_line} />}
        {shipmentMode === MODES[0] && (
          <TableCell width={WIDTH_POSTING[9]}>
            <CheckButton
              checked={postingsPrint[order.posting_number]}
              onSelect={() => changePostingPrint(order.posting_number)}
              disabled={is_disabled_print}
            />
          </TableCell>
        )}
        {shipmentMode === MODES[0] && (
          <TableCell width={WIDTH_POSTING[8]} center={true}>
            <Button
              type={TYPE_BUTTONS.WHITE}
              className={styles.white_button}
              onClick={() => printSticker(order)}
              disabled={is_disabled_print}
            >
              <Icon src={barcode_image} width="35px" />
            </Button>
            <CheckButton
              checked={order.is_printed}
              small
              style={{ marginLeft: '10px' }}
              onSelect={() => changePrintStatus([order.posting_number], !order.is_printed)}
              disabled={is_disabled_print}
            />
          </TableCell>
        )}
        <TableCell width={WIDTH_POSTING[0]}>
          {isAdmin ? (
            <Link to={TO_POSING(order.posting_number)} className={styles.link} target="_blank">
              {order.posting_number}
            </Link>
          ) : (
            <>{order.posting_number} </>
          )}
          {order.market === 'wb' && <span className={styles.wb_sticker}>{order.sticker_parts?.second}</span>} <br />
          <Row style={{ width: '100%' }}>
            {(isMany || globalSearchCompleted) && (
              <NavLink
                state={{ posting_number: order.posting_number }}
                to={TO_SHIPMENT(order.shipment_id)}
                // target={'_blank'}
                className={styles.scan_time}
                style={{ fontSize: '16px', width: 'auto', marginRight: '5px' }}
              >
                {getDateMonth(order.dates.shipment_date)}
              </NavLink>
            )}
            {order.market === 'wb' && <TextGrey style={{ fontSize: '13px', color: '#6c11c9' }}>{order.shop}</TextGrey>}
            {order.market === 'yandex' && (
              <TextGrey style={{ fontSize: '13px', color: 'rgb(193 61 0)' }}>{order.shop}</TextGrey>
            )}
            {order.market === 'ozon' && (
              <TextGrey style={{ fontSize: '13px', color: 'rgb(19,79,231)' }}>{order.shop}</TextGrey>
            )}
            {order.market === 'megamarket' && (
              <TextGrey style={{ fontSize: '13px', color: 'rgb(13,131,25)' }}>{order.shop}</TextGrey>
            )}
          </Row>
          <div className={styles.scan_time} onMouseOver={() => setInfo(true)} onMouseLeave={() => setInfo(false)}>
            {scan_time_order} <br />
            {info && (
              <DropDown styles={styles.all_info} close={() => setInfo(false)}>
                <WhiteBlock styles={styles.init}>
                  <TextGrey style={{ marginBottom: '4px' }}>Пропик:</TextGrey>
                  <Text fontSize={18} fontWeight={600}>{`${order.scan_user.pick}`}</Text>
                  <div className={styles.scan_time}>({scan_time_order})</div>

                  {second_scan_time_order && (
                    <>
                      <TextGrey style={{ marginTop: '15px', marginBottom: '4px' }}>Упаковка:</TextGrey>
                      <Text fontSize={18} fontWeight={600}>{`${order.scan_user.packager}`}</Text>
                      <div className={styles.scan_time}>
                        ({second_scan_time_order}){' '}
                        {order.scan_id.packager && (
                          <span>
                            {' '}
                            - сканер id: <span style={{ fontWeight: '600' }}>{order.scan_id.packager}</span>{' '}
                          </span>
                        )}
                      </div>
                    </>
                  )}

                  {sort_scan_time_order && (
                    <>
                      <TextGrey style={{ marginTop: '15px', marginBottom: '4px' }}>Сортировка:</TextGrey>
                      <Text fontSize={18} fontWeight={600}>{`${order.scan_user.sort}`}</Text>
                      <div className={styles.scan_time}>
                        ({sort_scan_time_order}){' '}
                        {order.scan_id.sort && (
                          <span>
                            {' '}
                            - сканер id: <span style={{ fontWeight: '600' }}>{order.scan_id.sort}</span>{' '}
                          </span>
                        )}
                      </div>
                    </>
                  )}
                </WhiteBlock>
              </DropDown>
            )}
          </div>
        </TableCell>
        <TableCell width={WIDTH_POSTING[1]}>
          <Column>
            {order.products.map((p, k) => {
              const data = map[p.offer_id] || {};
              const img = data.images ? (data.images.length > 0 ? data.images : [default_image]) : [default_image];
              const scan_time = p.scan_time ? formFullDate(p.scan_time) : null;
              return (
                <Column key={`${order.posting_number}-${p.offer_id}-1`}>
                  <div key={k} className={styles.div_line_images}>
                    <div className={styles.wrapper}>
                      <img
                        onClick={() => openImageViewer(img)}
                        className={styles.preview}
                        src={img.length > 0 ? img[0] : undefined}
                      />
                    </div>
                    <Column>
                      <div className={styles.name}>
                        {`${p.ordered_quantity} x ${p.name}  `}
                        <div className={cn(styles.offer_id, p.status === 'Нет в наличии' && styles.red_text)}>
                          {p.offer_id}
                        </div>
                      </div>
                      {scan_time && (
                        <div className={styles.scan_time}>
                          {scan_time} {p.scan_user && `(${p.scan_user})`}
                        </div>
                      )}
                    </Column>
                  </div>

                  {p.chzn.is_has && (
                    <Row style={{ marginBottom: '10px' }}>
                      <TextGrey>Маркировка: </TextGrey>
                      {p.chzn.value.length > 0 && !p.chzn.is_missing && (
                        <p className={styles.chzn_num}>{p.chzn.value}</p>
                      )}
                      {p.chzn.is_missing && <p className={styles.chzn_not}>НЕТ МАРКИРОВКИ</p>}
                      <Button
                        className={styles.color_blue}
                        onClick={() => setOpenChzn({ open: true, product: p, posting: order })}
                      >
                        {p.chzn.value.length ? 'редактировать' : 'ввести маркировку'}
                      </Button>
                      {/*
                      <Input value={p.number_chzn} onBlur={(v) => changeData(p._id, 'number_chzn', v)} />
*/}
                    </Row>
                  )}
                </Column>
              );
            })}
          </Column>
        </TableCell>
        {shipmentMode && (
          <TableCell width={WIDTH_POSTING[6]} center={true}>
            <Column center={true}>
              {order.products.map((p, k) => (
                <Row key={`${order.posting_number}-${p.offer_id}-2`} className={styles.div_line}>
                  <RealQuantityInput
                    product={p}
                    onChangeProduct={(v) => onChangeProduct(order.posting_number, p._id, 'real_quantity', v)}
                  />
                </Row>
              ))}
            </Column>
          </TableCell>
        )}
        {shipmentMode === MODES[4] && (
          <>
            <TableCell width={WIDTH_POSTING[11]} center={true}>
              <Row>
                <PackagingMethodSelect
                  method={order.packaging_method}
                  onSelect={(v) => onChangePosting(order.posting_number, 'packaging_method', v.method)}
                />
                <Column style={{ marginLeft: '15px' }}>
                  {order.products.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Row key={`${order.posting_number}-${p.offer_id}-3`} className={styles.div_line}>
                      <Button onClick={() => onChangeProduct(order.posting_number, p._id, 'is_chzn', !p.chzn.is_has)}>
                        <Icon src={p.chzn.is_has ? chz_active_icon : chzn_icon} width={'40px'} />
                      </Button>
                    </Row>
                  ))}
                </Column>
              </Row>
            </TableCell>
            <TableCell width={WIDTH_POSTING[10]} center={true}>
              <Column style={{ alignItems: 'center' }}>
                {order.products.reduce((sum, item) => {
                  return sum + item.price * item.ordered_quantity;
                }, 0)}
              </Column>
            </TableCell>
            <TableCell width={WIDTH_POSTING[10]} center={true}>
              <Column style={{ alignItems: 'center' }}>
                {Math.ceil(
                  order.products.reduce((sum, item) => {
                    return sum + item.purchase * item.ordered_quantity;
                  }, 0),
                )}
              </Column>
            </TableCell>
          </>
        )}
        <TableCell width={WIDTH_POSTING[5]} center={true}>
          <Column>
            {order.products.map((p, k) =>
            // eslint-disable-next-line react/no-array-index-key
            {
              const if_arrived =
                (!p.arrived_date &&
                  p['diff'].status !== 'Резерв' &&
                  p['diff'].status !== 'Частичный резерв' &&
                  p['diff'].status !== 'Нет в наличии') ||
                (moment().diff(moment(p.arrived_date || p.dokup.date), 'h') < 0 &&
                  p['diff'].status !== 'Резерв' &&
                  p['diff'].status !== 'Частичный резерв');
              return (
                <Column style={{ minHeight: '40px' }}>
                  {if_arrived && false && (
                    <div style={{ color: 'red', fontWeight: '600', fontSize: '13px' }}>ЕЩЕ НЕ ПРИЕХАЛО!</div>
                  )}
                  <Row
                    key={`${order.posting_number}-${p.offer_id}-19`}
                    className={styles.div_line}
                    style={{ minHeight: '0px' }}
                    center={true}
                  >
                    {(p['diff'].comment || '').length > 0 ? (
                      <>
                        <Tooltip text={p['diff'].comment}>
                          {p.diff.status}{' '}
                          {p['diff'].value !== 0 && p['diff'].value !== null && ` (${p['diff'].value})`} *
                        </Tooltip>
                      </>
                    ) : (
                      <>
                        {p['diff'].status}{' '}
                        {p['diff'].value !== 0 && p['diff'].value !== null && ` (${p['diff'].value})`}
                      </>
                    )}
                  </Row>
                </Column>
              );
            },
            )}
          </Column>
        </TableCell>

        {shipmentMode === MODES[3] && (
          <>
            <TableCell width={WIDTH_POSTING[10]} center={true}>
              <Column style={{ alignItems: 'center', fontSize: '16px', fontWeight: '600' }}>
                {order.products.reduce((sum, item) => {
                  return sum + item.price * item.ordered_quantity;
                }, 0)}
              </Column>
              {/* <Column style={{ alignItems: 'center' }}>{order.calculation.total_price}</Column>*/}
            </TableCell>
            <TableCell width={WIDTH_POSTING[10]} center={true}>
              <Column style={{ alignItems: 'center' }}>
                {`- ${Math.ceil(
                  order.products.reduce((sum, item) => {
                    return sum + item.purchase * item.common_quantity;
                  }, 0),
                )}`}
              </Column>
            </TableCell>
            <TableCell width={WIDTH_POSTING[10]} center={true}>
              {order.market === 'wb' && (
                <CommissionWbBlock
                  commission={order.products[0]?.commission}
                  increasedHours={order.products[0]?.increasedHours}
                />
              )}
            </TableCell>

            <TableCell width={WIDTH_POSTING[14]} center={true}>
              {order.market === 'wb' && (
                <div
                  className={
                    order.products[0]?.profit?.rub > 0 && !isPenaltyCandidate
                      ? order.delivering_status_update_date
                        ? styles.green
                        : styles.blue
                      : isPenaltyCandidate
                        ? styles.grey
                        : styles.red
                  }
                >
                  {order.products[0]?.profit?.rub > 0 && '+'} {order.products[0]?.profit?.rub}
                  <span style={{ color: 'grey', fontSize: '12px' }}> / {order.products[0]?.profit?.percent}%</span>
                </div>
              )}
            </TableCell>
            <TableCell width={WIDTH_POSTING[10]} center={true}>
              {isPenaltyCandidate && (
                <div style={{ color: 'red', fontSize: '16px', fontWeight: '600' }}>-{penalty}</div>
              )}
            </TableCell>
          </>
        )}

        <TableCell width={WIDTH_POSTING[3]} center={true}>
          <PostingStatusWrap order={order}>
            {order.status === 'Ожидает отгрузки' && order.market === 'wb' && (
              <DateDifferent date={order.dates.created_at} only_hours={true} />
            )}

            {order.dates.delivering_date && order.market === 'ozon' && (
              <div
                className={
                  order.cancellation?.is_return ? styles.scan_time_posting_sc_white : styles.scan_time_posting_sc
                }
              >
                {formFullDate(order.dates.delivering_date)}
              </div>
            )}

            {order.delivering_status_update_date && order.market === 'wb' && isAdmin && (
              <>
                <div
                  style={{ textAlign: 'center' }}
                  className={
                    order.cancellation?.is_return ? styles.scan_time_posting_sc_white : styles.scan_time_posting_sc
                  }
                >
                  {`${formFullDate(order.delivering_status_update_date)}`}
                </div>
                <div>{`${moment(order.delivering_status_update_date).diff(
                  moment(order.dates.created_at),
                  'h',
                )}  ч.`}</div>
              </>
            )}
          </PostingStatusWrap>
        </TableCell>
        <TableCell width={WIDTH_POSTING[8]} center>
          {order.products.map((p, k) => (
            <Row key={`${order.posting_number}-${p.offer_id}-3`} className={styles.div_line}>
              <Input
                value={map[p.offer_id].sizes_package?.depth}
                onBlur={(v) => onChangeCard(order.market, order.shop, p.offer_id, 'depth', v)}
                center
              />
            </Row>
          ))}
        </TableCell>
        <TableCell width={WIDTH_POSTING[8]} center>
          {order.products.map((p, k) => (
            <Row key={`${order.posting_number}-${p.offer_id}-3`} className={styles.div_line}>
              <Input
                value={map[p.offer_id].sizes_package?.width}
                onBlur={(v) => onChangeCard(order.market, order.shop, p.offer_id, 'width', v)}
                center
              />
            </Row>
          ))}
        </TableCell>
        <TableCell width={WIDTH_POSTING[8]} center>
          {order.products.map((p, k) => (
            <Row key={`${order.posting_number}-${p.offer_id}-3`} className={styles.div_line}>
              <Input
                value={map[p.offer_id].sizes_package?.height}
                onBlur={(v) => onChangeCard(order.market, order.shop, p.offer_id, 'height', v)}
                center
              />
            </Row>
          ))}
        </TableCell>
        <TableCell width={WIDTH_POSTING[8]} center>
          {order.products.map((p, k) => (
            <Row key={`${order.posting_number}-${p.offer_id}-3`} className={styles.div_line}>
              <Input
                value={+(map[p.offer_id].sizes_package?.volume)?.toFixed(2)}
                disabled
                center
              />
            </Row>
          ))}
        </TableCell>
        {shipmentMode === MODES[2] && order.market === 'wb' && (
          <>
            <TableCell width={WIDTH_POSTING[11]}>
              {order.products.map((p, k) => (
                // eslint-disable-next-line react/no-array-index-key
                <Row key={`${order.posting_number}-${p.offer_id}-4`} className={styles.div_line}>
                  <Button type={TYPE_BUTTONS.GREEN} onClick={() => sendMetadataToMarket(order.posting_number, p._id)}>
                    Передать маркировку
                  </Button>
                </Row>
              ))}
            </TableCell>
            <TableCell width={WIDTH_POSTING[10]}>
              {order.products.map((p, k) => (
                // eslint-disable-next-line react/no-array-index-key
                <Row key={`${order.posting_number}-${p.offer_id}-5`} className={styles.div_line}>
                  <Row>
                    <p className={styles.chzn_num}>{p.chzn.value_sended}</p>
                    {p.chzn.value_sended && (
                      <Button
                        className={styles.delete_metadata}
                        onClick={() => deleteMetadataInMarket(order.posting_number, p._id)}
                      >
                        удалить
                      </Button>
                    )}
                  </Row>
                </Row>
              ))}
            </TableCell>
          </>
        )}

        {shipmentMode === MODES[3] && (
          <>
            <TableCell width={WIDTH_POSTING[10]}>
              {order.dates.created_at ? (
                <div className={styles.scan_time_posting}>{formFullDate(order.dates.created_at)}</div>
              ) : (
                '-'
              )}
            </TableCell>
            <TableCell width={WIDTH_POSTING[10]}>
              {order.delivering_status_update_date ? (
                <div className={styles.scan_time_posting}>{formFullDate(order.delivering_status_update_date)}</div>
              ) : (
                '-'
              )}
            </TableCell>
            <TableCell width={WIDTH_POSTING[10]} center={true}>
              <div
                style={order.delivering_status_update_date ? { fontWeight: 600, fontSize: '15px' } : { color: 'grey' }}
              >
                {moment(order.delivering_status_update_date).diff(moment(order.dates.created_at), 'h')}
              </div>
              {!order.delivering_status_update_date && <div style={{ fontSize: '12px' }}>Предположительно</div>}
            </TableCell>
            <TableCell width={WIDTH_POSTING[2]}>{(order.cancellation || { reason: '' }).reason}</TableCell>
          </>
        )}
        {(shipmentMode === MODES[1] || tab === 6) && (
          <>
            <TableCell width={WIDTH_POSTING[9]} />
            <TableCell width={WIDTH_POSTING[13]} center={true}>
              <Column style={{ alignItems: 'center' }}>
                {order.products.map((p, k) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <div
                    key={`${order.posting_number}-${p.offer_id}-6`}
                    className={styles.div_line}
                    style={{ fontSize: '15px', fontWeight: '600' }}
                  >
                    {p.provider_artnumber}
                  </div>
                ))}
              </Column>
            </TableCell>
            <TableCell width={WIDTH_POSTING[12]}>
              <Column>
                {order.products.map((p, k) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <div key={`${order.posting_number}-${p.offer_id}-7`} className={styles.div_line}>
                    <Select
                      select={p.dokup.status}
                      list={['Заказан', 'Нет в наличии', 'Нет']}
                      style={{ fontSize: '16px' }}
                      width={'150px'}
                      changeDifernceStatus
                      onSelect={(v) =>
                        onChangeProduct(order.posting_number, p._id, 'dokup_status', v === 'Нет' ? null : v)
                      }
                      {...props}
                    />
                  </div>
                ))}
              </Column>
            </TableCell>
            <TableCell width={WIDTH_POSTING[12]}>
              <Column>
                {order.products.map((p, k) => (
                  <div key={`${order.posting_number}-${p.offer_id}-8`} className={styles.div_line}>
                    <Select
                      select={p.dokup.provider_name}
                      list={providers.map((p) => p.name)}
                      style={{ fontSize: '16px' }}
                      width={'150px'}
                      changeDifernceStatus
                      onSelect={(v) => onChangeProduct(order.posting_number, p._id, 'dokup_provider', v)}
                      {...props}
                    />
                  </div>
                ))}
              </Column>
            </TableCell>
            <TableCell width={WIDTH_POSTING[0]}>
              <Column>
                {order.products.map((p, k) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <div key={`${order.posting_number}-${p.offer_id}-9`} className={styles.div_line}>
                    <DateInput
                      className={styles.date_input}
                      classNameCalendar={styles.date_input_calendar}
                      value={p.dokup.date}
                      onChange={(v) => onChangeProduct(order.posting_number, p._id, 'dokup_date', v)}
                    />
                  </div>
                ))}
              </Column>
            </TableCell>
            <TableCell width={WIDTH_POSTING[11]} center={true}>
              <Column>
                {order.products.map((p, k) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <div key={`${order.posting_number}-${p.offer_id}-10`} className={styles.div_line}>
                    <Select
                      select={p.shipment_diff === 'Нет' ? null : p.shipment_diff}
                      list={DIFF_STATUSES}
                      style={{ fontSize: '16px' }}
                      width={'188px'}
                      changeDifernceStatus
                      onSelect={(v) =>
                        onChangeProduct(order.posting_number, p._id, 'shipment_diff', v === 'Нет' ? '' : v)
                      }
                      {...props}
                    />
                    {shipmentMode === MODES[1] && (p.comment || '').length > 0 && (
                      <Tooltip text={p.comment} isShow={(p.comment.length || '') > 0}>
                        <Icon src={comment_red} style={{ marginLeft: '10px' }} width={'30px'} />
                      </Tooltip>
                    )}
                  </div>
                ))}
              </Column>
            </TableCell>
            <TableCell width={WIDTH_POSTING[11]} center={true}>
              <Column>
                {order.products.map((p, k) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <div key={`${order.posting_number}-${p.offer_id}-11`} className={styles.div_line}>
                    <Select
                      select={p.variance_process.status}
                      list={['Оформлен', 'Вычерк', 'Не заказывали', 'Списан', 'Нет']}
                      style={{ fontSize: '16px' }}
                      width={'150px'}
                      onSelect={(v) =>
                        onChangeProduct(order.posting_number, p._id, 'variance_status', v === 'Нет' ? '' : v)
                      }
                      {...props}
                    />
                  </div>
                ))}
              </Column>
            </TableCell>
          </>
        )}
        {shipmentMode === MODES[0] && tab !== 6 && (
          <>
            {tab !== 4 && (
              <>
                <TableCell width={WIDTH_POSTING[11]} center={true}>
                  <Column>
                    {order.products.map((p, k) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <div key={`${order.posting_number}-${p.offer_id}-12`} className={styles.div_line}>
                        <Select
                          select={p.shipment_diff === 'Нет' ? null : p.shipment_diff}
                          list={DIFF_STATUSES}
                          style={{ fontSize: '16px' }}
                          width={'188px'}
                          changeDifernceStatus
                          onSelect={(v) =>
                            onChangeProduct(order.posting_number, p._id, 'shipment_diff', v === 'Нет' ? '' : v)
                          }
                          {...props}
                        />
                        {shipmentMode === MODES[1] && p.comment.length > 0 && (
                          <Tooltip text={p.comment} isShow={p.comment.length > 0}>
                            <Icon src={comment_red} style={{ marginLeft: '10px' }} width={'30px'} />
                          </Tooltip>
                        )}
                      </div>
                    ))}
                  </Column>
                </TableCell>
                <TableCell width={WIDTH_POSTING[4]}>
                  <Column>
                    {order.products.map((p, k) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <div key={`${order.posting_number}-${p.offer_id}-14`} className={styles.div_line}>
                        <CommentPostingProductBlock
                          posting={order}
                          offer_id={p.offer_id}
                          onChange={(v) => onChangeProduct(order.posting_number, p._id, 'comment', v)}
                          width={'158px'}
                        />
                      </div>
                    ))}
                  </Column>
                </TableCell>
                <TableCell center={true} width={WIDTH_POSTING[5]}>
                  <Column style={{ alignItems: 'center' }}>
                    {order.products.map((p, k) => (
                      <div
                        style={{ textAlign: 'center', flexDirection: 'column' }}
                        key={`${order.posting_number}-${p.offer_id}-14`}
                        className={styles.div_line}
                      >
                        {p.arrived_date ? moment(getDateSolid(p.arrived_date)).format('DD.MM.YYYY') : '-'}
                        {p.dokup?.date && (
                          <span style={{ color: 'blue' }}>
                            {' '}
                            {p.dokup?.date ? moment(getDateSolid(p.dokup?.date)).format('DD.MM.YYYY') : '-'}
                          </span>
                        )}
                      </div>
                    ))}
                  </Column>
                </TableCell>
                {isExpress && (
                  <TableCell width={WIDTH_POSTING[11]}>
                    <Column>
                      {order.products.map((p, k) => {
                        let warehouse_id = map[p.offer_id]?.warehouse_id;
                        let warehouseCard = warehouseProductsMap[warehouse_id];
                        let is_reserve = warehouseCard?.sklad_data[order.sklad]?.history?.find(
                          (item) => item.posting_number === order.posting_number && item.action === 'express_reserve',
                        );
                        let is_write_off = warehouseCard?.sklad_data[order.sklad]?.history?.find(
                          (item) => item.posting_number === order.posting_number && item.action === 'write_off_express',
                        );

                        return (
                          <div key={`${order.posting_number}-${p.offer_id}-144`} className={styles.div_line}>
                            {is_reserve && (
                              <Button
                                type={TYPE_BUTTONS.WHITE}
                                disabled={is_write_off || p.diff?.status !== 'Резерв'}
                                onClick={() =>
                                  onChangeWarehouseReserve(
                                    warehouseCard.id,
                                    'write_off_express',
                                    p.common_quantity,
                                    order.posting_number,
                                    order.sklad,
                                    `Экспресс ${order.market}: ${order.posting_number}`,
                                  )
                                }
                              >
                                Списать
                              </Button>
                            )}
                            <div
                              style={{ fontSize: '15px', fontWeight: '600' }}
                            >
                              {`   ${warehouseCard?.sklad_data?.[order.sklad]?.address} / (${warehouseCard?.sklad_data?.[order.sklad]?.stock} шт.)`}
                            </div>
                          </div>
                        );
                      })}
                    </Column>
                  </TableCell>
                )}
              </>
            )}

            <TableCell width={WIDTH_POSTING[4]}>
              <Column style={{ alignItems: 'center' }}>
                {order.products.map((p, k) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <div key={`${order.posting_number}-${p.offer_id}-15`} className={styles.div_line}>
                    <ProviderList selectProviderId={p.provider_id} disabled={true} />
                  </div>
                ))}
              </Column>
            </TableCell>
            <TableCell width={WIDTH_POSTING[5]}>
              <Column>
                {order.products.map((p, k) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <div key={`${order.posting_number}-${p.offer_id}-16`} className={styles.div_line}>
                    <Input value={p.provider_artnumber} readOnly={true} center={true} />
                  </div>
                ))}
              </Column>
            </TableCell>
            <TableCell width={WIDTH_POSTING[5]}>
              <Column>
                {order.products.map((p, k) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <div key={`${order.posting_number}-${p.offer_id}-17`} className={styles.div_line}>
                    <Input value={p.common_quantity / p.ordered_quantity} readOnly={true} center={true} />
                  </div>
                ))}
              </Column>
            </TableCell>
            <TableCell width={WIDTH_POSTING[7]}>
              <Column>
                {order.products.map((p, k) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <Row key={`${order.posting_number}-${p.offer_id}-18`}>
                    <div style={{ width: '200px' }}>
                      <BarcodesBlock
                        barcodes={p.barcodes}
                        onAdd={(b) => onChangeProduct(order.posting_number, p._id, 'barcodes', b, 'add')}
                        onRemove={(b) => onChangeProduct(order.posting_number, p._id, 'barcodes', b, 'pull')}
                      />
                    </div>
                  </Row>
                ))}
              </Column>
            </TableCell>
            {order.market === 'wb' && (
              <TableCell width={WIDTH_POSTING[7]}>
                <DateDifferent date={order.dates.created_at} />
                <TextGrey style={{ width: '100%', fontSize: 14 }}>{formFullDate(order.dates.created_at)}</TextGrey>
              </TableCell>
            )}
          </>
        )}
        {isViewerOpen && <ImageViewer src={images} currentIndex={0} onClose={closeImageViewer} />}
      </TableLine>
    </>
  );
};

export default PostingLine;
